"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorWrapper = exports.ProductGrid = exports.TrashIconWrapper = exports.PriceSave = exports.PriceValue = exports.PriceStriked = exports.PriceFrom = exports.Footer = exports.TagsWrapper = exports.Title = exports.Sku = exports.TitleWrapper = exports.InfoWrapper = exports.ImageWrapper = exports.Wrapper = exports.TagStyled = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const core_1 = require("@material-ui/core");
exports.TagStyled = (0, flora_react_1.styled)(flora_react_1.Tag, {
    marginRight: '$2',
    marginBottom: '$1',
});
exports.Wrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    maxWidth: '425px',
    boxSizing: 'border-box',
    background: '$backgroundPrimary',
    marginBottom: '$2',
    '&:first-child': {
        marginTop: '$5',
    },
});
exports.ImageWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    marginRight: '$2',
    '> div': {
        width: '42px',
    },
});
exports.InfoWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    paddingRight: '$1',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
});
exports.TitleWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    flexDirection: 'column',
    width: '100%',
});
exports.Sku = (0, flora_react_1.styled)(flora_react_1.Text, {
    marginBottom: '$2',
});
exports.Title = (0, flora_react_1.styled)(flora_react_1.Text, {
    marginBottom: '$1',
    fontSize: '$bodySmall',
    lineHeight: '$short',
    fontWeight: '$medium',
});
exports.TagsWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: '$12',
    flexWrap: 'wrap',
});
exports.Footer = (0, flora_react_1.styled)(flora_react_1.Flex, {
    marginTop: '-$2',
    width: '100%',
    flexDirection: 'column',
    boxSizing: 'border-box',
    marginRight: '$4',
    paddingLeft: 'calc(42px + $2)',
});
exports.PriceFrom = (0, flora_react_1.styled)(({ children }) => ((0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "exceptionsAuxiliarRegular", color: "$nonInteractivePredominant" }, { children: children }))));
exports.PriceStriked = (0, flora_react_1.styled)((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "exceptionsAuxiliarRegular", color: "$nonInteractivePredominant" }, props, { children: children })));
}, {
    textDecoration: 'line-through',
    textDecorationColor: '$error-standard',
});
exports.PriceValue = (0, flora_react_1.styled)(({ children }) => ((0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "bodyLargeStandardRegular", color: "$nonInteractivePredominant" }, { children: children }))));
exports.PriceSave = (0, flora_react_1.styled)(({ children }) => ((0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: "auxiliarMini", color: "$nonInteractivePredominant" }, { children: children }))));
exports.TrashIconWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    cursor: 'pointer',
    fontSize: '$6',
    color: '$nonInteractiveAuxiliar',
});
exports.ProductGrid = (0, flora_react_1.styled)((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({}, props, { children: children }));
}, {
    display: 'flex',
    alignItems: 'center',
    variants: {
        type: {
            product: {
                marginBottom: '$4 !important',
            },
            increment: {
                justifyContent: 'flex-end',
                '[class*="IncrementDecrement"]': {
                    maxWidth: '90px',
                },
            },
            price: {
                justifyContent: 'flex-start',
                alignItems: 'center',
            },
            trashIcon: {
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
            },
        },
    },
});
exports.AnchorWrapper = (0, flora_react_1.styled)(flora_react_1.Flex, {
    cursor: 'pointer',
    '&:hover span': {
        color: '$actionableDefault',
    },
});
